const LEGACY_SAFARI_MAX_VERSION = 13;

const isSafariUserAgent = (userAgent: string): boolean =>
  userAgent.includes('Safari') &&
  !userAgent.includes('Chrome') &&
  !userAgent.includes('Chromium') &&
  !userAgent.includes('Android');

const getSafariMajorVersion = (): number | null => {
  if (typeof navigator === 'undefined') {
    return null;
  }

  const userAgent = navigator.userAgent;
  if (!isSafariUserAgent(userAgent)) {
    return null;
  }

  const versionMatch = userAgent.match(/Version\/(\d+)/);
  if (!versionMatch) {
    return null;
  }

  return Number.parseInt(versionMatch[1], 10);
};

export const isLegacySafari = (): boolean => {
  const safariVersion = getSafariMajorVersion();
  return safariVersion !== null && safariVersion <= LEGACY_SAFARI_MAX_VERSION;
};
